import { Stat } from '@chakra-ui/react'

export default ({ label, value }) => {
  return (
    <Stat.Root>
      <Stat.Label>{label}</Stat.Label>
      <Stat.ValueText>
        {value}
      </Stat.ValueText>
    </Stat.Root>
  )
}
